import React, { memo } from 'react';
import { createRouter } from '../../../router';
import { RouterProvider as Router5Provider } from 'react-router5';

const RouterProvider: React.FC = memo(({ children }) => {
  return <Router5Provider router={createRouter()}>{children}</Router5Provider>;
});

export default RouterProvider;
